import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Input, Button, Select } from 'antd';
import { useLocation } from 'react-router-dom';
import Pagination from '../Component/Pagination';


const { Option } = Select;


const AllApi = () => {
    const [totalPages, setTotalPages] = useState(0);
    const [filter, setFilter] = useState('ALL');

    const [page, setPage] = useState(1);
    const [size, setSize] = useState(50);
    const [data, setData] = useState([]);
    const [searchUsernames, setSearchUsernames] = useState('');
      const [statusFilter, setStatusFilter] = useState("ALL");
        const [filter1, setFilter1] = useState("FUTURES");
      
    

    const location = useLocation();


    const onPageChange = (page) => {
        setPage(page);
    };

    const handlePageSizeChange = (size) => {
        setSize(size);
    };

    // Fetch filtered APIs
    const ViewAPIs = (size, page, tradeType, usernames,status,exchangetype) => {
        const jwt = localStorage.getItem('jwt');

        const postData = {
            jwt: jwt,
            page_no: page,
            page_size: size,
            // Include tradeType only if not 'ALL'
        };

        if (tradeType !== "ALL") {
            postData.api_type = [tradeType];
        }

        if (usernames) {
            postData.username = usernames.split(',').map((name) => name.trim());
        }

        if (status && status !== "ALL") {
            postData.status = [status]; // Add the selected status to the API request
          }

          if (exchangetype !== "ALL") {
            postData.exchange_type = [exchangetype];
          } else {
            postData.exchange_type = ["SPOT", "FUTURE"];
          }

        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            url: process.env.REACT_APP_API + '/bot/view_apis',
            data: postData,
        })
            .then((res) => {
                if (res?.data?.Success === 'No transactions yet!') {
                    setData([]);
                } else {
                    setData(res?.data?.Success || []);
                }
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // Fetch total pages
    const ViewTotalApis = (size, page, tradeType, usernames,status,exchangetype) => {
        const jwt = localStorage.getItem('jwt');

        const postData = {
            jwt: jwt,
            page_no: page,
            page_size: size,

        };

        if (tradeType !== "ALL") {
            postData.api_type = [tradeType];
        }

        if (exchangetype !== "ALL") {
            postData.exchange_type = [exchangetype];
          } else {
            postData.exchange_type = ["SPOT", "FUTURE"];
          }

        if (usernames) {
            postData.username = usernames.split(',').map((name) => name.trim());
        }

        if (status && status !== "ALL") {
            postData.status = [status]; // Add the selected status to the API request
          }

        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            url: process.env.REACT_APP_API + '/bot/total_page_view_apis',
            data: postData,
        })
            .then((res) => {
                setTotalPages(res?.data?.Success);
            })
            .catch((err) => {
                console.error(err);
            });
    };

    useEffect(() => {
        ViewTotalApis(size, page, filter, searchUsernames,statusFilter,filter1);
        ViewAPIs(size, page, filter, searchUsernames,statusFilter,filter1); // Pass the filter to the API call
    }, [page, size, filter,statusFilter,filter1]);

    const dataSource = data.map((item) => ({
        API_ID: item?.API_ID || '--',
        Username: item?.Username || '--',
        Created_At: item?.Created_At || '--',
        Exchange_Type: item?.Exchange_Type || '--',
        API_Name: item?.API_Name || '--',
        Exchange: item?.Exchange || '--',
        Status: item?.Status || '--',
        Total_Investment: item?.Total_Investment || '--',
        Trade_Type: item?.Trade_Type || '--',
        Approved: item?.Approved || '--',
        Account_Balance: item?.Account_Balance || '--',
    }));

    const defaultColumns = [
        {
            title: 'Date Time',
            dataIndex: 'Created_At',
            key: 'Created_At',
            className: "whitespace-nowrap text-left",
            width: undefined
        },
        {
            title: 'API_ID',
            dataIndex: 'API_ID',
            key: 'API_ID',
            className: "whitespace-nowrap text-left",
            width: undefined,

            render: (text) => (
                <div
                    className={`border-l-4 rounded pl-2 ${text === 'PAPER' ? 'border-[#122b45]' : 'border-[#76c3c5]'
                        }`}
                >
                    {text}
                </div>
            ),
        },
        {
            title: 'Username',
            dataIndex: 'Username',
            key: 'Username',
            className: "whitespace-nowrap text-left",
            width: undefined
        },
        // {
        //     title: 'Type',
        //     dataIndex: 'Exchange',
        //     key: 'Exchange',
        //     className: "whitespace-nowrap text-left" 
        // },
        {
            title: 'Exchange Type',
            dataIndex: 'Exchange_Type',
            key: 'Exchange_Type',
            className: "whitespace-nowrap text-left",
            width: undefined
        },
        {
            title: 'Trade Type',
            dataIndex: 'Trade_Type',
            key: 'Trade_Type',
            className: "whitespace-nowrap text-left",
            width: undefined
        },
        {
            title: 'API Name',
            dataIndex: 'API_Name',
            key: 'API_Name',
            className: "whitespace-nowrap text-left",
            width: undefined
        },
        {
            title: 'Account Balance',
            dataIndex: 'Account_Balance',
            key: 'Account_Balance',
            className: "whitespace-nowrap text-left",
            width: undefined
        },
        {
            title: 'Total Investment',
            dataIndex: 'Total_Investment',
            key: 'Total_Investment',
            className: "whitespace-nowrap text-left",
            width: undefined
        },
        {
            title: 'Approved',
            dataIndex: 'Approved',
            key: 'Approved',
            className: "whitespace-nowrap text-left",
            width: undefined
        },
        {
            title: 'Status',
            dataIndex: 'Status',
            key: 'Status',
            className: "whitespace-nowrap text-left",
            width: undefined
        },
    ];

    const handleSearch = () => {
        // setPage(1); // Reset to the first page
        ViewAPIs(size, page, filter, searchUsernames,statusFilter,filter1);
        ViewTotalApis(size, page, filter, searchUsernames,statusFilter,filter1)
    };

    return (
        <div>
            <div className="p-2">
                <div className="flex mb-4 items-center justify-between">
                    <div className="flex items-center">
                        <Input
                            placeholder="Search username"
                            value={searchUsernames}
                            onChange={(e) => setSearchUsernames(e.target.value.trim().toLowerCase())}
                            style={{ width: '300px', marginRight: '8px' }}
                        />
                        <Button onClick={handleSearch}>
                            Search
                        </Button>
                    </div>
                    <div>
                        {['ALL', 'LIVE', 'PAPER'].map((type) => (
                            <button
                                key={type}
                                className={`mr-2 2xl:px-4 py-1 rounded-full w-20 2xl:w-24 shadow-md ${filter === type
                                    ? 'bg-colorSecondaryDark text-white border-2 border-white'
                                    : 'bg-white text-colorSecondaryDark'
                                    }`}
                                onClick={() => setFilter(type)}
                            >
                                {type}
                            </button>
                        ))}
                    </div>

                    {/* Filter Mode Buttons */}
  <div className="flex gap-2 justify-center w-full lg:w-auto">
    {["FUTURES", "SPOT"].map((type) => (
      <button
        key={type}
        className={`mr-2 px-6 py-2 rounded-lg shadow-md w-full lg:w-auto ${filter1 === type
          ? "bg-colorSecondaryDark text-white border-2 border-white"
          : "bg-white text-colorSecondaryDark"}`}
        onClick={() => setFilter1(type)}
      >
        {type}
      </button>
    ))}
  </div>

                    <div className="flex items-center gap-2 w-full lg:w-auto">
    <label htmlFor="statusFilter" className="text-sm">Status:</label>
    <Select
      id="statusFilter"
      defaultValue="ALL"
      className="w-full lg:w-40"
      onChange={(value) => setStatusFilter(value)}
    >
      {["ALL", "ACTIVE", "INACTIVE", "PAUSED", "STOP"].map((status) => (
        <Option key={status} value={status}>
          {status}
        </Option>
      ))}
    </Select>
  </div>

                </div>
            </div>

            <Table
                dataSource={dataSource}
                columns={defaultColumns}
                pagination={false}
                scroll={{
                    x: 1000,
                }}
            />
<Pagination
                        totalPages={totalPages}
                        currentPage={page}
                        pageSize={size}
                        onPageChange={onPageChange}
                        onPageSizeChange={handlePageSizeChange}
                    />

        </div>
    );
};

export default AllApi;
